"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useState } from "react";
import { ToolIcon } from "@/components/ToolIcon";
import type { Tool } from "@/lib/tools";
export function ToolCard(t0) {
  const $ = _c(16);
  const {
    tool,
    onClick
  } = t0;
  const [warm, setWarm] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setWarm(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const prefetch = t1;
  const t2 = `/${tool.slug}/`;
  const t3 = warm ? null : false;
  let t4;
  if ($[1] !== tool.category) {
    t4 = <ToolIcon category={tool.category} />;
    $[1] = tool.category;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== tool.name) {
    t5 = <span className="text-[17px] font-semibold">{tool.name}</span>;
    $[3] = tool.name;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== tool.description) {
    t6 = <span className="text-sm text-muted-foreground">{tool.description}</span>;
    $[5] = tool.description;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <span className="flex flex-col gap-0.5">{t5}{t6}</span>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== onClick || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t7) {
    t8 = <Link href={t2} prefetch={t3} onPointerEnter={prefetch} onFocus={prefetch} onTouchStart={prefetch} onClick={onClick} className="flex items-start gap-3.5 rounded-[14px] border bg-card p-5 text-ink transition-colors hover:border-line-strong hover:bg-canvas">{t4}{t7}</Link>;
    $[10] = onClick;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}